/**
 * @description: Copied from https://git.perkbox.io/perkbox-services/auth/auth-app/-/blob/master/public/error_codes/errors.go
 */

enum Auth {
  BusinessDisabled = "PBAUTHBusinessDisabled",
  CommentNotFound = "PBAUTHCommentNotFound",
  DeviceNotFound = "PBAUTHDeviceNotFound",
  EmptyField = "PBAUTHEmptyField",
  IAdminNotFound = "PBAUTHIAdminNotFound",
  IAdminEmailExists = "PBAUTHIAdminEmailExists",
  IAdminLoginRejected = "PBAUTHIAdminLoginRejected",
  InvalidEmailSubdomain = "PBAUTHInvalidEmailSubdomain",
  InvalidFeatureFlag = "PBAUTHInvalidFeatureFlag",
  InvalidField = "PBAUTHInvalidField",
  InvalidLoginDetails = "PBAUTHInvalidLoginDetails",
  InvalidOTAC = "PBAUTHInvalidOTAC",
  InvalidPassword = "PBAUTHInvalidPassword",
  InvalidPhoneNumber = "PBAUTHInvalidPhoneNumber",
  InvalidSearch = "PBAUTHInvalidSearch",
  InvalidSignature = "PBAUTHInvalidSignature",
  InvalidToken = "PBAUTHInvalidToken",
  InvalidUserId = "PBAUTHInvalidUserId",
  LoginAttemptsExceeded = "PBAUTHLoginAttemptsExceeded",
  MFAUserNotFound = "PBAUTHMFAUserNotFound",
  MFAUserAlreadyExists = "PBAUTHMFAUserAlreadyExists",
  NotBefore = "PBAUTHNotBefore",
  OTACAttemptsExceeded = "PBAUTHOTACAttemptsExceeded",
  OTACExpired = "PBAUTHOTACExpired",
  RegisteredDeviceExpired = "PBAUTHRegisteredDeviceExpired",
  SessionEntryTooLarge = "PBAUTHSessionEntryTooLarge",
  SessionExpired = "PBAUTHSessionExpired",
  UserAlreadyActivated = "PBAUTHUserAlreadyActivated",
  UserDisabled = "PBAUTHUserDisabled",
  InvalidMFA = "PBAUTHInvalidMFA",
  AttemptsExceededMFA = "PBAUTHMFAAttemptsExceeded"
}

export default Auth
